import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function createItem(data) {
  return Axios({
    url: `${baseUrl()}/item`,
    method: "POST",
    data: data,
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
